import React, { useState } from "react"
import ReactPlayer from 'react-player'
import { useTranslation, Trans } from 'react-i18next';

import thumbnail from "../assets/img/postprod/thumbnail/Akira_3D_Thumbnail.png"

export default function App() {

  const { t, i18n } = useTranslation();

  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const onLoadedData = () => {
    setIsVideoLoaded(true);
  };

  return (
    <>
      <div className="row main-row">

        <div className="column column-60 column-offset-20 container">

          <div className="column " id="akira-title">

            <ReactPlayer
              url={"https://www.youtube.com/watch?v=YcK93qNTGB8"}
              playing={true}
              controls={true}
              muted={false}
              volume={0.7}
              playsinline={true}
              onReady={onLoadedData}
              light={thumbnail}
              width={"76vw"}
              height={"41.08vw"}
            />

            <div className="section">

              <p>
                <Trans i18nKey="description.intro">
                </Trans>
              </p>

              <ul>
                <li><a href="https://linktr.ee/mirbix02" target="blank">Bissoli Miriam</a>,</li>
                <li><a href="https://www.instagram.com/acclo_andstuff/" target="blank">Giordano Angelo</a>,</li>
                <li><a href="https://www.linktr.ee/turoxd" target="blank">Turini Davide</a>.</li>
              </ul>
            </div>
          </div>

        </div >
      </div>

    </>
  )
}